import { TextField, Grid, InputAdornment } from "@mui/material";
import { dollarize } from "../../../../../../../utils/commonFunctions/dollarize";

import "./benefitSelection.css";

const BenefitSelection = ({ premiumAmount }: { premiumAmount: number }) => {
	return (
		<div className="benefit-selection" id="benefit-selection">
			<div className="benefit-container" id="benefit-container">
				<div className="information-container">
					Mark the box or boxes for each type of Group Insurance you are applying for. All Insurance amounts
					are subject to the limitations and exclusions stated in the policy and certificate.
				</div>
				<div className="basic-group-header">Basic Group Insurance</div>
				<div className="section-header-container">
					<Grid container spacing={1}>
						<Grid item xs={3} sm={3} md={3} lg={3} xl={3} className="Employer-header">
							<div className="employer-label">Employer Completes this Section</div>
							<div className="class-header">
								<Grid container spacing={1}>
									<Grid item xs={6} sm={6} md={6} lg={6} xl={6} className="class-label">
										Class
									</Grid>
									<Grid item xs={6} sm={6} md={6} lg={6} xl={6} className="effective-date-label">
										Effective Date
									</Grid>
								</Grid>
							</div>
						</Grid>
						<Grid item xs={4} sm={4} md={4} lg={4} xl={4} className="insurance-header">
							Type of Insurance
						</Grid>
						<Grid item xs={3} sm={3} md={3} lg={3} xl={3} className="amount-insurance-header">
							Amount of Insurance
						</Grid>
						<Grid item xs={2} sm={2} md={2} lg={2} xl={2} className="premium-header">
							Total Premium
						</Grid>
					</Grid>
				</div>
				<div className="optional-group-header">Voluntary/Optional Group Insurance</div>
				<div className="section-value-container">
					<Grid container spacing={1}>
						<Grid item xs={3} sm={3} md={3} lg={3} xl={3} className="Employer-header">
							<Grid container spacing={1}>
								<Grid item xs={6} sm={6} md={6} lg={6} xl={6} className="class-value">
									<TextField
										className="text-field"
										id="text-field"
										variant="standard"
										name="class"
										style={{
											width: "100px",
											borderRadius: 50
										}}
									/>
								</Grid>
								<Grid item xs={6} sm={6} md={6} lg={6} xl={6} className="effective-date-value">
									<span className="textfield-container">
										<TextField
											className="date-field"
											id="text-field"
											variant="standard"
											placeholder="MM"
											name="month"
											style={{
												width: "30px",
												borderRadius: 50
											}}
										/>
									</span>
									/
									<span className="textfield-container">
										<TextField
											className="date-field"
											id="text-field"
											variant="standard"
											placeholder="DD"
											name="day"
											style={{
												marginLeft: "3px",
												width: "30px",
												borderRadius: 50
											}}
										/>
									</span>
									/
									<span className="textfield-container">
										<TextField
											className="date-field"
											id="text-field"
											variant="standard"
											placeholder="YYYY"
											name="year"
											style={{
												marginLeft: "3px",
												width: "50px",
												borderRadius: 50
											}}
										/>
									</span>
								</Grid>
							</Grid>
						</Grid>
						<Grid item xs={4} sm={4} md={4} lg={4} xl={4} className="insurance-value">
							<span className="buy-up-text">Buy-Up Long Term Disability (LTD): </span>
							<span className="yes-radio-field">
								<input type="checkbox" id="buy-up-ltd" name="buy_up_yes" /> {" "}
								<label htmlFor="yes">Yes</label>
							</span>
							<span className="no-radio-field">
								<input type="checkbox" id="buy-up-ltd" name="buy_up_no" /> {" "}
								<label htmlFor="no">No*</label>
							</span>
						</Grid>
						<Grid item xs={3} sm={3} md={3} lg={3} xl={3} className="amount-insurance-value">
							<span className="monthly-benefit-text">Monthly Benefit Amount: </span>
							<span>
								<TextField
									className="text-field"
									id="text-field"
									variant="standard"
									name="monthly_benefit_amount"
									InputProps={{
										startAdornment: <InputAdornment position="start">$</InputAdornment>
									}}
									style={{
										width: "70px",
										borderRadius: 50
									}}
								/>
							</span>
						</Grid>
						<Grid item xs={2} sm={2} md={2} lg={2} xl={2} className="premium-value">
							<span>
								<TextField
									className="text-field"
									id="text-field"
									variant="standard"
									name="total_premium"
									value={dollarize(premiumAmount)}
									style={{
										width: "80px",
										borderRadius: 50
									}}
								/>
							</span>
						</Grid>
					</Grid>
				</div>
			</div>
			<div className="note-container" id="note-container">
				*By Selecting No, application for insurance at a later date may require further medical information
				and/or a physical exam, which will be at my own expense.
			</div>
			<div className="deduction-container" id="deduction-container">
				--Actual deductions may vary slightly from above illustrations due to rounding--.
			</div>
		</div>
	);
};

export default BenefitSelection;
